export { default } from './ReferralActivityHistory';
